// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__AcWGP","footerRow":"Footer_footerRow__6v-C6"};